import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskPhone(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={(e) => {
        onChange({
          target: {
            value: e.target.value,
          },
        });
      }}
      mask="(999) 999-9999"
    />
  );
}

InputMaskPhone.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskPhone.js